import axios from "axios";

import { CEDARMAP_TOKEN } from "Constants/App";
import { IPoint } from "Types/point";

interface ILocationData {
  formattedAddress: string;
  city: string;
  address: string;
  district: string;
  province: string;
}

export async function getRouteCoordinates(points: IPoint[]): Promise<{ result: IPoint[]; distance: number }> {
  if (points.length <= 1) return { result: [], distance: 0 };

  let result: IPoint[] = [];
  let distance: number = 0;

  const pointsString = points.map((point) => `${point.lat},${point.lng}`).join(";");
  const url = `https://api.cedarmaps.com/v1/direction/cedarmaps.driving/${pointsString}?access_token=${CEDARMAP_TOKEN}`;

  await axios.get(url).then((response) => {
    const { coordinates } = response.data.result.routes[0].geometry;
    result = coordinates.map((item: number[]) => ({ lat: item[1], lng: item[0] }));
    distance = response.data.result.routes[0].distance;
  });

  return { result, distance };
}
export async function getLocationData(location: IPoint): Promise<ILocationData> {
  const url = `https://api.cedarmaps.com/v1/geocode/cedarmaps.streets/${location.lat},${location.lng}.json?access_token=${CEDARMAP_TOKEN}`;

  return axios.get(url).then((res) => {
    const { result } = res.data;
    return { ...result, formattedAddress: result.formatted_address };
  });
}
